import axios from "axios";
import {urlConfig} from "../config";

export default class IngestionService {

    static getStatus(cp) {

        const ingestionStatusInstance = axios.create({baseURL: `${urlConfig.bffUrl}/ingestion/${cp}/status`});
        // const ingestionStatusInstance = axios.create({baseURL: `http://localhost:1339/ingestion/${cp}/status`});

        return ingestionStatusInstance.get();
    }

}